import moment from 'moment';
import axios from 'axios';
import { noop } from 'lodash';
import React, { useState, useRef, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Captcha from 'react-google-recaptcha';
import { v4 as uuidv4 } from 'uuid';
import {
  Button,
  Typography,
  TextField,
  Box,
  Link,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Feedback, Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate, NavLink } from 'react-router-dom';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import Select from '../../../components/select';
import ErrorSnackBar from '../../../components/snackBar/ErrorSnackBar';
import { getRequest, postRequest } from '../../../services';
import URL, { employerUrls } from '../../../constants/urls';
import {
  getEducationList,
  getExperienceLevel,
  getRoleList,
} from '../../../formatter/commonBootstrap';
import REGEX_PATTERN from '../../../constants/regex';
import ERROR_MESSAGE from '../../../constants/errorMsgs';
import VALIDATION_VALUES from '../../../constants/validationValues';
import UI from '../../../constants/ui';
import URL_ID from '../../../constants/footerUrlIds';
import useQuery from '../../../hooks/useQuery';
import { getRecaptchaKey } from '../../../formatter/google.bootstrap';
import LOGIN_TYPE from '../../../constants/loginType';

import {
  EMPTY_ARRAY,
  DEFAULT_COMPANY_ID,
  DEFAULT_COLLEGE_ID,
} from '../../../constants';
import { API_URL } from '../../../constants/apiUrls';
import SuggestNameDialog from '../../../components/suggestNameDialog/SuggestNameDialog';
import {
  setRequestsComplete,
  setRerenderpermissions,
  setHideLoginDialog,
  setContext,
} from '../../../../redux/userSlice';
import STATUS_CODE from '../../../constants/statusCode';
import { showSnackBar } from '../../../../redux/snackBarSlice';
import {
  getLoginDetailFromSession,
  setLoginDetailInSession,
} from '../../../helpers/sessionDetails';
import {
  getAvailablePointsUser,
  getNotificationCountUser,
} from '../../../../redux/apiCalls';
import useMobileDevice, {
  ismallMobileDevice,
} from '../../../hooks/useMobileDevice';
import { getLoginTypeFromSetting } from '../../../formatter/settings.bootstrap';
import Styles from './Register.module.css';
import { COMMON_LOGIN_STATE } from '../../../constants/loginStates.constants';
import CONTEXT_TYPE from '../../loginDialog/loginDialog.constants';
import AutoSuggestion from '../../../components/autoSuggestion';
import { extractSkillId, getIdFromName } from '../../../helpers/skillId';
import STORAGE_KEY from '../../../constants/storageKey';
import SocailMediaLogin from '../SocailMediaLogin';
import PortalDatePicker from '../../../components/portalDatePicker';
import {
  DISABLED_FUTURE_DATE_AND_MONTH_FORMAT,
  MONTH_FORMAT,
  YEAR_MONTH,
} from '../../../constants/datepicker';
import { getDateInYYMMDD, validateDates } from '../../../formatter/date';
import OTPDialog from '../oauthLogin/OTPDialog';

export function requestDTO(formData, email, base64Encode) {
  if (base64Encode) {
    return { ...formData, email, password: base64Encode };
  }
  return { ...formData, email };
}
export function requestLoginDTO(formData, username, base64Encode) {
  return { ...formData, username, password: base64Encode };
}

function removeEmptyStrings(obj) {
  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
    const result = {};
    Object.keys(obj).forEach((key) => {
      const value = removeEmptyStrings(obj[key]);
      if (value !== '') {
        result[key] = value;
      }
    });
    return result;
  }
  if (Array.isArray(obj)) {
    return obj.map(removeEmptyStrings);
  }

  return obj;
}

function Register(props) {
  const { setShowNavBar, setHideRegisterDialog } = props;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
    getValues,
    clearErrors,
    trigger,
    setError,
  } = useForm({ mode: 'onChange' });

  const navigate = useNavigate();
  const loginTypeFromSettings = getLoginTypeFromSetting();
  const params = new URLSearchParams(window.location.search);
  const errorMessage = params.get('message');
  const isOtpScreen = params.get('otp');
  const dispatch = useDispatch();
  const isLoginDialogOpen = useSelector((state) => state.user.showLoginDialog);
  const userName = useSelector((state) => state.user.username);
  const password = useSelector((state) => state.user.password);
  const context = useSelector((state) => state.user.context);
  const captchaRef = useRef(null);
  const [isCompanyChangeDisable, setisCompanyChangeDisable] = useState(false);
  const [verifyOtp, setVerifyOtp] = useState();
  const [countdown, setCountdown] = useState(loginTypeFromSettings?.resendotp);
  const [opensnackbar, setSnackbarOpen] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [registerData, setRegisterData] = useState();
  const [token, setToken] = useState();
  const [contextFromScreen, setContextFromScreen] = useState(0);
  const [spaceWarning, setSpaceWarning] = useState(false);
  const [isSkillWithRatingExists, setIsSkillWithRatingExists] = useState(false);
  const [shouldShowSocialMedia, setShouldShowSocialMedia] = useState(true);

  const [openOtpDialog, setOpenOtpDialog] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const isReferralCodeInURL = searchParams.get('referrer');
  const searchParamsName = searchParams.get('name');
  const searchParamsEmail = searchParams.get('email');
  const roleList = getRoleList();
  const query = useQuery();
  const referrerId = query.get('referrer');
  const experienceLevel = getExperienceLevel();
  const getReferrIdFromSession = sessionStorage.getItem(
    STORAGE_KEY.REFERRER_ID
  );

  const base64ToText = (base64) => {
    const decodedString = atob(base64);
    return decodedString;
  };

  useEffect(() => {
    if (errorMessage) {
      dispatch(
        showSnackBar({
          setopen: true,
          message: errorMessage,
          severity: 'error',
          duration: 5000,
        })
      );
    }
  }, [errorMessage]);

  useEffect(() => {
    if (searchParamsEmail && searchParamsName) {
      setValue('email', base64ToText(searchParamsEmail));
      setValue('name', base64ToText(searchParamsName));
      setValue('role', roleList[0]?.id);
    }
  }, []);

  useEffect(() => {
    if (
      contextFromScreen === CONTEXT_TYPE.OTP_FORM ||
      context === CONTEXT_TYPE.OTP_FORM
    ) {
      setOpenOtpDialog(true);
    } else {
      setOpenOtpDialog(false);
    }
  }, [context, contextFromScreen]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen({ setopen: false });
  };

  const getSkillsPayload = () => {
    const role = watch('role');
    const skillArray = [];

    if (role !== LOGIN_TYPE.EMPLOYER) {
      const skills = getValues('skill') || [];

      for (let i = 0; i < skills.length; i += 1) {
        const mappingId = uuidv4();
        const id = getIdFromName(skills[i]);
        if (id) {
          skillArray.push({ id, name: skills[i], mappingId });
        }
      }
    }

    return skillArray;
  };

  const isSmallDevice = ismallMobileDevice();
  const isMobileDevice = useMobileDevice();
  const isSpotOnMockInterview = sessionStorage.getItem(
    STORAGE_KEY.IS_SPOT_ON_MOCK_INTERVIEWS
  );
  const role = watch('role');
  const degree = watch('degree');

  const onClickBtn = (data) => {
    let payload = data;

    if (role === LOGIN_TYPE.CANDIDATE) {
      const experience = parseInt(data.experienceLevel, 10);
      if (!degree && experience === 1) {
        setError('degree', {
          type: 'custom',
          message: ERROR_MESSAGE.REQ_ERROR_MSG,
        });
        return;
      }
      if (
        // student
        experience === 1 &&
        data.from &&
        data.to &&
        !validateDates(data.from, data.to)
      ) {
        setError('to', {
          type: 'custom',
          message: ERROR_MESSAGE.TO_DATE_GREATER_THAN_FROM,
        });
        return;
      }
      const studentPayload = {
        role: data.role,
        email: data.email,
        password: data.password,
        name: data.name,
        mobile: data.mobile,
        experienceLevel: experience,
        jobexp: -2,
        skills: getSkillsPayload(),
        recentEducation: {
          college: data.college,
          collegeId: data.collegeId,
          degree: data.degree,
          from: getDateInYYMMDD(data.from),
          to: getDateInYYMMDD(data.to),
          mappingId: uuidv4(),
        },
        linkedin: data.linkedin,
        refCode: data.refCode,
      };

      const fresherPayload = {
        role: data.role,
        email: data.email,
        password: data.password,
        name: data.name,
        mobile: data.mobile,
        experienceLevel: experience,
        jobexp: -1,
        skills: getSkillsPayload(),
        linkedin: data.linkedin,
        refCode: data.refCode,
      };

      const experiencePayload = {
        role: data.role,
        email: data.email,
        password: data.password,
        name: data.name,
        mobile: data.mobile,
        experienceLevel: experience,
        jobexp: parseInt(data.jobexp, 10),
        skills: getSkillsPayload(),
        linkedin: data.linkedin,
        refCode: data.refCode,
      };

      if (experience === 1) {
        payload = studentPayload;
      } else if (experience === 2) {
        payload = fresherPayload;
      } else {
        payload = experiencePayload;
      }
    } else {
      const companyPayload = {
        role: data.role,
        email: data.email,
        password: data.password,
        name: data.name,
        mobile: data.mobile,
        company: data.company,
        companyid: data.companyid,
        refCode: data.refCode,
      };
      payload = companyPayload;
    }

    setSpaceWarning(false);
    setRegisterData(payload);
    const base64Encode = btoa(payload.password);
    const email = payload.email.toLowerCase();
    const captchaToken = captchaRef.current.getValue();
    const requestPayload = requestDTO(
      payload,
      email,
      payload?.password && base64Encode
    );
    setIsLoading(true);

    const output = removeEmptyStrings(requestPayload);
    postRequest(
      searchParamsEmail
        ? `/register/oauth-user?captcha=${captchaToken}${
            referrerId || getReferrIdFromSession
              ? `&referrer=${referrerId || getReferrIdFromSession}`
              : ''
          }`
        : `/register/user?captcha=${captchaToken}${
            referrerId ? `&referrer=${referrerId}` : ''
          }`,
      output
    )
      .then((res) => {
        setSnackbarOpen({
          setopen: true,
          message: res.msg,
          severity: 'success',
        });
        if (role === LOGIN_TYPE.CANDIDATE) {
          dispatch(setContext(CONTEXT_TYPE.OTP_FORM));
          setContextFromScreen(CONTEXT_TYPE.OTP_FORM);
        } else if (isLoginDialogOpen && role === LOGIN_TYPE.EMPLOYER) {
          dispatch(setHideLoginDialog());
          navigate(`${URL.VERIFY_EMAIL}?email=${requestPayload.email}`);
          window.location.reload();
        } else if (role === LOGIN_TYPE.EMPLOYER) {
          navigate(`${URL.VERIFY_EMAIL}?email=${requestPayload.email}`);
        }
      })
      .catch((error) => {
        setSnackbarOpen({
          setopen: true,
          message: error.msg,
          severity: 'error',
        });
      })
      .finally(() => {
        captchaRef.current.reset();
        setIsLoading(false);
      });
  };
  const afterLogin = async () => {
    const userDetail = getLoginDetailFromSession();
    if (userDetail.role === LOGIN_TYPE.CANDIDATE) {
      getAvailablePointsUser(dispatch);
      getNotificationCountUser(dispatch);
      dispatch(setRequestsComplete());
      dispatch(setRerenderpermissions());
    }
    if (isLoginDialogOpen === true) {
      setHideRegisterDialog(true);
      if (
        isSpotOnMockInterview &&
        userDetail?.state === COMMON_LOGIN_STATE.INACTIVE
      ) {
        dispatch(setHideLoginDialog());
        window.location.reload();
      } else {
        dispatch(setContext(CONTEXT_TYPE.CANDIDATE_FORM));
      }
    }
    if (
      isLoginDialogOpen === false &&
      userDetail.role === LOGIN_TYPE.CANDIDATE
    ) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      navigate(URL.CANDIDATE_PROFILE);
    }
  };
  const handleLogin = () => {
    setIsLoading(true);
    getRequest(API_URL.CREDENTIAL)
      .then((resp) => {
        setLoginDetailInSession(resp);
        const loggedInUserRole = resp.role;
        if (loggedInUserRole === LOGIN_TYPE.CANDIDATE) {
          getRequest(API_URL.LAST_ASSESSMENT)
            .then((response) => {
              if (response?.showmsg) {
                dispatch(
                  showSnackBar({
                    setopen: true,
                    message: response?.msg,
                    severity: 'info',
                    duration: 10000,
                  })
                );
              }
            })
            .catch((error) => {
              setSnackbarOpen({
                setopen: true,
                message: error.msg,
                severity: 'error',
              });
            });
          afterLogin();
        }
      })
      .finally(() => setIsLoading(false));
  };

  const otpWatch = watch('otp');

  useEffect(() => {
    if (otpWatch) {
      setToken(otpWatch);
    }
  }, [otpWatch]);

  const handleLoginAPI = () => {
    const username = registerData?.email.toLowerCase() || userName;
    const base64Encode = btoa(registerData?.password || password);
    const requestPayload = requestLoginDTO(
      registerData,
      username,
      base64Encode
    );
    delete requestPayload.role;
    delete requestPayload.name;
    delete requestPayload.mobile;
    delete requestPayload.email;
    const requestPayloads = new URLSearchParams(requestPayload);
    setIsLoading(true);
    axios
      .post(API_URL.LOGIN, requestPayloads, {
        withCredentials: true,
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      })
      .then((res) => {
        setSnackbarOpen({
          setopen: true,
          message: res?.data?.msg,
          severity: 'success',
        });
        if (res.data.code === STATUS_CODE.SUCCESSFULLY_LOGIN) {
          handleLogin();
        }
      })
      .catch((error) => {
        setSnackbarOpen({
          setopen: true,
          message: error.response?.data?.msg,
          severity: 'error',
        });
      })
      .finally(() => setIsLoading(false));
  };

  const handleVerifyOtp = () => {
    setVerifyOtp(true);
    const email =
      registerData?.email.toLowerCase() || userName || searchParamsEmail;
    const candidateUrl = `/register/verifyotp?otp=${token}&email=${email}`;
    const employerUrl = `/register/confirm?token=${token}`;
    const url =
      registerData?.role === LOGIN_TYPE.CANDIDATE ? candidateUrl : employerUrl;
    getRequest(url)
      .then((res) => {
        setVerifyOtp(false);
        if (!searchParamsEmail) {
          handleLoginAPI();
        }
        setSnackbarOpen({
          setopen: true,
          message: res.msg,
          severity: 'success',
        });
        if (res.code === STATUS_CODE.CONFIRM_TOKEN_SUCCESS) {
          setSnackbarOpen({
            setopen: true,
            message: res.msg,
            severity: 'success',
          });
          if (searchParamsEmail) {
            handleLogin();
          }
        }
      })
      .catch((error) => {
        if (
          error.code === STATUS_CODE.INVALID_TOKEN ||
          STATUS_CODE.EXPIRE_TOKEN
        ) {
          setSnackbarOpen({
            setopen: true,
            message: error.msg,
            severity: 'error',
          });
        }
      })
      .finally(() => {
        setVerifyOtp(false);
      });
  };

  useEffect(() => {
    let timer;
    if (openOtpDialog) {
      if (countdown > 0) {
        timer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);
      }
    }
    return () => {
      clearInterval(timer);
    };
  }, [countdown, openOtpDialog]);

  const handleResendClick = () => {
    setCountdown(loginTypeFromSettings?.resendotp);
    const email =
      registerData?.email.toLowerCase() || userName || searchParamsEmail;
    getRequest(`/register/resendotp?email=${email}`)
      .then((res) => {
        setSnackbarOpen({
          setopen: true,
          message: res.msg,
          severity: 'success',
        });
      })
      .catch((error) => {
        setSnackbarOpen({
          setopen: true,
          message: error.msg,
          severity: 'error',
        });
      })
      .finally(() => setIsLoading(false));
  };
  const [values, setValues] = useState({
    password: '',
    showPassword: false,
  });
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const recaptchaKey = getRecaptchaKey();
  const setCompanyWithId = (object) => {
    setValue('company', object?.label || object?.name);
    if (object?.label || object?.name) setisCompanyChangeDisable(true);
    setValue('companyid', object?.id || DEFAULT_COMPANY_ID);
  };
  const handleCompanyChange = () => {
    if (role !== LOGIN_TYPE.EMPLOYER) return;
    setisCompanyChangeDisable(false);
    const email = watch('email');
    if (email)
      getRequest(`${API_URL.AUTOCOMPLETE_COMPANY}?email=${email}`).then(
        (response) => {
          setCompanyWithId(response);
        }
      );
  };

  const [isSuggestDialogOpen, setSuggestDialogVisible] = useState(false);

  useEffect(() => {
    handleCompanyChange();
    if (role === LOGIN_TYPE.EMPLOYER) {
      setShouldShowSocialMedia(false);
    }
    if (!role || role === LOGIN_TYPE.CANDIDATE) {
      setShouldShowSocialMedia(true);
    }
  }, [role]);

  useEffect(() => {
    setShowNavBar(true);
  }, EMPTY_ARRAY);

  useEffect(() => {
    if (isOtpScreen) {
      setOpenOtpDialog(true);
    }
  }, [isOtpScreen]);

  const setSkill = (name) => {
    setSpaceWarning(false);

    const lastInput = name[name.length - 1]?.trim().toLowerCase();
    const updatedName = name.slice(0, name.length - 1);

    const isDuplicate = updatedName.some(
      (str) => str?.trim().toLowerCase() === lastInput
    );

    if (isDuplicate) {
      name.pop();
      setValue('skill', [...name]);
      setIsSkillWithRatingExists(true);
    } else {
      const allValid = name.every((str) => extractSkillId(str?.trim()) !== -1);
      if (!allValid) {
        setSpaceWarning(true);
      } else {
        setSpaceWarning(false);
      }

      setValue('skill', [...name]);
      setIsSkillWithRatingExists(false);
    }

    trigger('skill');
  };

  const setCollegeWithId = (object) => {
    setValue('college', object?.label || object);
    setValue('collegeId', object?.id || DEFAULT_COLLEGE_ID);
  };

  const renderFooterLine = () =>
    isLoginDialogOpen ? (
      <Typography sx={{ color: 'gray', mx: 4, mt: 1, textAlign: 'center' }}>
        {UI.ALREADY_ON_COMPANY_IN}&nbsp;
        <span
          style={{ color: '#1976d2', cursor: 'pointer' }}
          onClick={() => dispatch(setContext(CONTEXT_TYPE.LOGIN_FORM))}
        >
          {UI.LOGIN}
        </span>
      </Typography>
    ) : (
      <Typography sx={{ color: 'gray', mx: 4, mt: 1, textAlign: 'center' }}>
        {UI.ALREADY_ON_COMPANY_IN}{' '}
        <Link
          sx={{ color: '#1976d2' }}
          underline="none"
          as={NavLink}
          to={URL.LOGIN}
        >
          {UI.LOGIN}
        </Link>
      </Typography>
    );

  // const onChangeFresher = (event) => {
  //   const isChecked = event.target.checked;
  //   setValue('fresher', isChecked, { shouldValidate: true });
  //   setValue('jobexp', undefined, { shouldValidate: true });
  //   setIsFresher(isChecked);
  // };

  const onChangeExperienceType = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === 'fresher' || selectedValue === 'student') {
      setValue('jobexp', '');
      clearErrors('jobexp');
    } else if (selectedValue === 'experienced') {
      trigger('jobexp');
    }
  };
  const renderRegisterFields = () => (
    <div
      style={{
        boxShadow: '0px 0px 3px #48B2FF29',
        backgroundColor: '#fff',
        borderRadius: '8px',
        maxWidth: isMobileDevice ? 350 : 650,
      }}
      className="card px-3 py-2 container"
    >
      <Typography align="left" fontSize="2rem" mb={4}>
        {UI.REGISTER}
      </Typography>
      <div className={isMobileDevice ? 'p-2' : 'col-md-6 p-2'}>
        <label>{UI.ROLE}</label>
        <Box component="span" sx={{ color: '#d32f2f' }}>
          *
        </Box>
        <Select
          inputId="role"
          name="role"
          control={control}
          options={getRoleList()}
          isRequired
          fullWidth
          id="role"
          defaultValue={UI.SELECT_OPTION}
          {...register('role')}
          className={Styles.smallField}
          disabled={searchParamsName || searchParamsEmail}
        />
        {errors.role && (
          <span className="mandatory">{errors.role.message}</span>
        )}
      </div>
      <div
        className={isMobileDevice ? 'd-flex flex-column' : 'd-flex flex-wrap'}
      >
        <div className={isMobileDevice ? 'px-2' : 'col-md-6 px-2'}>
          <label>{UI.EMAIL}</label>
          <Box component="span" sx={{ color: '#d32f2f' }}>
            *
          </Box>
          <div className="mb-2 mt-1">
            <TextField
              {...register('email', {
                required: ERROR_MESSAGE.REQ_ERROR_MSG,
                pattern: {
                  value: REGEX_PATTERN.EMAIL_FORMAT,
                  message: ERROR_MESSAGE.EMAIL_VALIDATION,
                },
                onChange: (event) => {
                  setValue('email', event.target.value.toLowerCase());
                },
              })}
              fullWidth
              type="email"
              id="email"
              variant="outlined"
              size="small"
              placeholder={UI.ENTER_EMAIL}
              name="email"
              onBlur={!errors.email && handleCompanyChange}
              className={Styles.smallField}
              disabled={searchParamsEmail}
            />
            {errors.email && (
              <Box>
                <span className="mandatory">{errors.email.message}</span>
              </Box>
            )}
          </div>
        </div>
        {!searchParamsEmail && !searchParamsName && (
          <div className={isMobileDevice ? 'px-2' : 'col-md-6 px-2'}>
            <div className="d-flex align-items-center">
              {UI.PASSWORD}
              <Tooltip title={ERROR_MESSAGE.PASSWORD_INFO}>
                <HelpOutlineIcon
                  sx={{ fontSize: 16, ms: 4 }}
                  color="disabled"
                />
              </Tooltip>
              <Box component="span" sx={{ color: '#d32f2f' }}>
                *
              </Box>
            </div>

            <div className="mb-2">
              <OutlinedInput
                fullWidth
                {...register('password', {
                  required: ERROR_MESSAGE.REQ_ERROR_MSG,
                  pattern: {
                    value: REGEX_PATTERN.PASSWORD_FORMAT,
                    message: ERROR_MESSAGE.PASSWORD_INFO,
                  },
                  maxLength: {
                    value: VALIDATION_VALUES.MAX_VALUE_16,
                    message:
                      ERROR_MESSAGE.MAX_ERROR_MSG +
                      VALIDATION_VALUES.MAX_VALUE_16,
                  },
                })}
                className={Styles.smallField}
                id="outlined-adornment-password"
                variant="outlined"
                type={values.showPassword ? 'text' : 'password'}
                value={values.password}
                placeholder={UI.ENTER_PASSWORD}
                size="small"
                name="password"
                onChange={handleChange('password')}
                endAdornment={
                  <InputAdornment
                    position="end"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    <Tooltip
                      title={
                        values.showPassword
                          ? UI.HIDE_PASSWORD
                          : UI.SHOW_PASSWORD
                      }
                    >
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                }
              />
              {errors.password && (
                <Box maxWidth={290}>
                  <span className="mandatory">{errors.password.message}</span>
                </Box>
              )}
            </div>
          </div>
        )}
        {role && role === LOGIN_TYPE.EMPLOYER && (
          <div className={isMobileDevice ? 'px-2' : 'col-md-6 px-2 mt-1'}>
            <label>{UI.COMPANY_NAME}</label>
            <Box component="span" sx={{ color: '#d32f2f' }}>
              *
            </Box>
            <OutlinedInput
              {...register('company', {
                required: ERROR_MESSAGE.REQ_ERROR_MSG,
              })}
              fullWidth
              type="text"
              id="company"
              variant="outlined"
              className={`${Styles.smallField} mb-2`}
              placeholder={UI.COMPANY_NAME}
              disabled={isCompanyChangeDisable}
              name="company"
              size="small"
              endAdornment={
                isCompanyChangeDisable &&
                !errors.email && (
                  <InputAdornment
                    position="end"
                    onClick={() => {
                      setSuggestDialogVisible(true);
                    }}
                  >
                    <Tooltip title={UI.SUGGEST_NAME}>
                      <IconButton edge="end">
                        <Feedback />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                )
              }
            />
            {errors.company && (
              <Box>
                <span className="mandatory">{errors.company.message}</span>
              </Box>
            )}
          </div>
        )}
        <div className={isMobileDevice ? 'px-2' : 'col-md-6 px-2'}>
          <label>{UI.NAME}</label>
          <Box component="span" sx={{ color: '#d32f2f' }}>
            *
          </Box>
          <div className="mb-2 mt-1">
            <TextField
              {...register('name', {
                required: ERROR_MESSAGE.REQ_ERROR_MSG,
                pattern: {
                  value: REGEX_PATTERN.NAME_FORMAT,
                  message: ERROR_MESSAGE.NAME_VALIDATION_MESSAGE,
                },
              })}
              fullWidth
              type="text"
              id="name"
              variant="outlined"
              size="small"
              placeholder={UI.NAME}
              name="name"
              className={Styles.smallField}
              disabled={searchParamsName}
            />
            {errors.name && (
              <Box>
                <span className="mandatory">{errors.name.message}</span>
              </Box>
            )}
          </div>
        </div>

        <div
          className={
            isMobileDevice
              ? 'px-2'
              : searchParamsName
              ? 'col-md-12 px-2'
              : 'col-md-6 px-2'
          }
        >
          <label>{UI.PHONE_NUMBER}</label>
          <Box component="span" sx={{ color: '#d32f2f' }}>
            *
          </Box>
          <div className="mb-2 mt-1">
            <TextField
              {...register('mobile', {
                required: ERROR_MESSAGE.REQ_ERROR_MSG,
                pattern: {
                  value: REGEX_PATTERN.NUMERIC_FORMAT,
                  message: ERROR_MESSAGE.PHONE_VALIDATION_MESSAGE,
                },
                minLength: {
                  value: VALIDATION_VALUES.MIN_VALUE,
                  message:
                    ERROR_MESSAGE.MIN_ERROR_MSG + VALIDATION_VALUES.MIN_VALUE,
                },
                maxLength: {
                  value: VALIDATION_VALUES.MAX_VALUE_15,
                  message:
                    ERROR_MESSAGE.MAX_ERROR_MSG +
                    VALIDATION_VALUES.MAX_VALUE_15,
                },
              })}
              className={Styles.smallField}
              fullWidth
              type="text"
              size="small"
              id="number"
              inputProps={{
                maxLength: VALIDATION_VALUES.MAX_VALUE_15,
                minLength: VALIDATION_VALUES.MAX_VALUE_10,
              }}
              variant="outlined"
              placeholder={UI.ENTER_WHATSAPP_PHONE_NUMBER}
              name="mobile"
            />
            {errors.mobile && (
              <Box>
                <span className="mandatory">{errors.mobile.message}</span>
              </Box>
            )}
          </div>
        </div>
        {role && role === LOGIN_TYPE.CANDIDATE && (
          <div className={isMobileDevice ? 'px-2' : 'col-md-12 px-2'}>
            <div className="col-md-12">
              <label htmlFor="skill" className="form-label col-12">
                {UI.SKILLS}
                <Box component="span" sx={{ color: '#d32f2f' }}>
                  *
                </Box>
                <AutoSuggestion
                  id="skill"
                  name="skill"
                  values={getValues('skill') || []}
                  setValues={setSkill}
                  placeholder={ERROR_MESSAGE.SKILL_PLACEHOLDER}
                  control={control}
                  isSkillField
                  isMulti
                  {...register('skill', {
                    validate: (value) => {
                      if (!value || value.length === 0) {
                        return `${ERROR_MESSAGE.MIN_ERROR_MSG}${VALIDATION_VALUES.MIN_VALUE}`;
                      }
                      if (value.length > VALIDATION_VALUES.MAX_VALUE_64) {
                        return `${ERROR_MESSAGE.MAX_ERROR_MSG}${VALIDATION_VALUES.MAX_VALUE_64}`;
                      }
                      return true;
                    },
                  })}
                />

                {errors.skill ? (
                  <span className="mandatory">{errors.skill.message}</span>
                ) : isSkillWithRatingExists ? (
                  <span className="mandatory">
                    {ERROR_MESSAGE.DUPLICATE_SKILL_ERROR_MESSAGE}
                  </span>
                ) : (
                  spaceWarning && (
                    <span className="mandatory">
                      {ERROR_MESSAGE.SPACE_WARNING}
                    </span>
                  )
                )}
              </label>
            </div>
          </div>
        )}
        {role && role === LOGIN_TYPE.CANDIDATE && (
          <div className={isMobileDevice ? 'px-2' : 'col-md-12 px-2'}>
            <span className="subtitle-1">Experience</span>
            <Box component="span" sx={{ color: '#d32f2f' }}>
              *
            </Box>

            <div className="form-check d-flex flex-row justify-content-between my-2">
              {experienceLevel.map((level) => (
                <div key={level.id}>
                  <input
                    type="radio"
                    id={`level-${level.id}`}
                    value={level.id}
                    defaultChecked={level.id === 2}
                    className="form-check-input"
                    {...register('experienceLevel', {
                      onChange: (e) => {
                        onChangeExperienceType(e);
                        if (level.id !== 2) {
                          setValue('jobexp', '');
                          clearErrors('jobexp');
                        }
                        trigger('jobexp');
                      },
                    })}
                  />
                  <label htmlFor={`level-${level.id}`} className="ms-1">
                    I am {level.value}
                  </label>
                </div>
              ))}
            </div>

            {parseInt(getValues('experienceLevel'), 10) === 3 && (
              <>
                <label
                  htmlFor="jobexp"
                  style={{ width: '100%' }}
                  className="mt-2"
                >
                  <input
                    id="jobexp"
                    type="number"
                    step="0.01"
                    min={VALIDATION_VALUES.ZERO_VALUE}
                    placeholder={UI.WORK_EXPERIENCE_IN_YEAR}
                    className="form-control"
                    {...register('jobexp', {
                      validate: (value) => {
                        const numericValue = parseFloat(value);

                        if (!value) {
                          return ERROR_MESSAGE.REQ_ERROR_MSG;
                        }

                        if (numericValue < VALIDATION_VALUES.DECIMAL_ONE) {
                          return `${ERROR_MESSAGE.MIN_VALUE_MSG}${VALIDATION_VALUES.DECIMAL_ONE}`;
                        }

                        return true;
                      },
                    })}
                  />
                </label>
                {errors.jobexp && (
                  <span className="mandatory my-1" style={{ float: 'right' }}>
                    {errors.jobexp.message}
                  </span>
                )}
              </>
            )}

            {parseInt(getValues('experienceLevel'), 10) === 1 && (
              <>
                <div className="col-md-12">
                  <label htmlFor="degree" className="form-label col-12">
                    {UI.DEGREE}
                    <Box component="span" sx={{ color: '#d32f2f' }}>
                      *
                    </Box>
                    <Controller
                      name="degree"
                      control={control}
                      rules={{
                        required: ERROR_MESSAGE.REQ_ERROR_MSG,
                      }}
                      render={({ field }) => (
                        <Select
                          id="degree"
                          inputId="degree"
                          {...field}
                          options={getEducationList()}
                          placeholder="Select your degree"
                          name="degree"
                          control={control}
                        />
                      )}
                    />
                  </label>
                  {errors.degree && (
                    <span className="mandatory">
                      {ERROR_MESSAGE.REQ_ERROR_MSG}
                    </span>
                  )}
                </div>

                <div className="col-md-12">
                  <label htmlFor="college" className="form-label col-12">
                    {UI.COLLEGE_UNIVERSITY}
                    <Box component="span" sx={{ color: '#d32f2f' }}>
                      *
                    </Box>
                    <AutoSuggestion
                      id="college"
                      name="college"
                      values={getValues('college')}
                      setValues={setCollegeWithId}
                      placeholder={UI.COLLEGE}
                      control={control}
                      {...register('college', {
                        required: ERROR_MESSAGE.REQ_ERROR_MSG,
                        validate: (value) =>
                          value?.trim() !== '' || ERROR_MESSAGE.INVALID_COLLEGE,
                      })}
                    />
                  </label>
                  {errors.college && (
                    <span className="mandatory">{errors.college.message}</span>
                  )}
                </div>

                <div className="d-flex flex-row justify-content-between">
                  <div className="col-md-5 mt-1">
                    <label htmlFor="from" className="form-label col-12">
                      {UI.FROM}
                      <Box component="span" sx={{ color: '#d32f2f' }}>
                        *
                      </Box>
                      <PortalDatePicker
                        control={control}
                        fields={YEAR_MONTH}
                        name="from"
                        id="from"
                        error={errors.from}
                        config={DISABLED_FUTURE_DATE_AND_MONTH_FORMAT}
                        {...register('from', {
                          required: ERROR_MESSAGE.REQ_ERROR_MSG,
                          validate: (value) => {
                            if (!value) return ERROR_MESSAGE.REQ_ERROR_MSG;
                            const date = new Date(value);
                            return (
                              date <= moment().endOf('month').toDate() ||
                              ERROR_MESSAGE.FUTURE_DATE
                            );
                          },
                        })}
                      />
                    </label>
                  </div>

                  <div className="col-md-5 mt-1">
                    <label htmlFor="to" className="form-label col-12">
                      {UI.TO}
                      <Box component="span" sx={{ color: '#d32f2f' }}>
                        *
                      </Box>
                      <PortalDatePicker
                        control={control}
                        fields={YEAR_MONTH}
                        name="to"
                        id="to"
                        error={errors.to}
                        config={MONTH_FORMAT}
                        {...register('to', {
                          required: ERROR_MESSAGE.REQ_ERROR_MSG,
                          validate: (value) => {
                            const fromDate = new Date(getValues('from'));
                            const toDate = new Date(value);
                            return (
                              (toDate >= fromDate &&
                                toDate <= moment().endOf('month').toDate()) ||
                              ERROR_MESSAGE.INVALID_DATE_RANGE
                            );
                          },
                        })}
                      />
                    </label>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {role && role === LOGIN_TYPE.CANDIDATE && (
          <div className="px-2 w-100 mb-2">
            <label htmlFor="linkedin" className="mt-1">
              {UI.LINKEDIN}
            </label>
            <TextField
              {...register('linkedin', {
                pattern: {
                  value: REGEX_PATTERN.NAME_FORMAT,
                  message: ERROR_MESSAGE.NAME_VALIDATION_MESSAGE,
                },
              })}
              fullWidth
              type="text"
              id="linkedin"
              variant="outlined"
              size="small"
              placeholder={UI.LINKEDIN_LINK}
              name="linkedin"
            />
            {errors.linkedin && (
              <Box>
                <span className="mandatory">{errors.linkedin.message}</span>
              </Box>
            )}
          </div>
        )}

        {role && !isReferralCodeInURL && (
          <div
            className={
              isMobileDevice ? 'px-2' : !role ? 'w-100 px-2 ' : 'col-md-6 px-2'
            }
          >
            <label htmlFor="refCode" className="mt-1">
              {UI.REFERRAL_CODE}
            </label>

            <TextField
              {...register('refCode', {
                maxLength: {
                  value: VALIDATION_VALUES.MAX_VALUE_10,
                  message:
                    ERROR_MESSAGE.MAX_ERROR_MSG +
                    VALIDATION_VALUES.MAX_VALUE_10,
                },
                minLength: {
                  value: VALIDATION_VALUES.MIN_VALUE,
                  message:
                    ERROR_MESSAGE.MAX_ERROR_MSG + VALIDATION_VALUES.MIN_VALUE,
                },
              })}
              fullWidth
              placeholder={UI.PLACEHOLDER_REFERRAL_CODE}
              id="refCode"
              size="small"
              error={!!errors.refCode?.message}
            />
            {errors.refCode && (
              <Box>
                <span className="mandatory">{errors.refCode.message}</span>
              </Box>
            )}
          </div>
        )}
      </div>
      <div className="px-2">
        <div style={{ marginTop: 14, marginBottom: 2 }}>
          <Captcha
            sitekey={recaptchaKey}
            ref={captchaRef}
            size={isSmallDevice ? 'compact' : 'normal'}
          />
        </div>
        <Typography
          align="center"
          sx={{
            fontSize: '10px',
            mt: 2,
            mb: 2,
            letterSpacing: '1px',
          }}
        >
          {UI.BY_CLICKING_AGREE_JOIN_YOU_AGREE_TO_THE_COMPANY_IN}{' '}
          <span className="color-1D8FF2 cursorPointer ms-1">
            <Link
              href={`${URL.INFORMATION}/${URL_ID.PRIVACY}`}
              underline="none"
              target="_blank"
            >
              {UI.PRIVACY_POLICY}
            </Link>
          </span>
          <br /> {UI.AND}{' '}
          <span className="color-1D8FF2 cursorPointer ms-1">
            <Link
              href={`${URL.INFORMATION}/${URL_ID.TERMS}`}
              underline="none"
              target="_blank"
            >
              {UI.TERM_AND_CONDITIONS}
            </Link>
          </span>
        </Typography>
        <Button
          fullWidth
          size="large"
          variant="contained"
          type="submit"
          sx={{ mb: 2 }}
          disabled={isLoading}
          startIcon={
            isLoading && <CircularProgress size="1rem" color="inherit" />
          }
          className={Styles.smallField}
        >
          {UI.REGISTER}
        </Button>
        {!searchParamsEmail &&
          !searchParamsName &&
          shouldShowSocialMedia &&
          !employerUrls.has(window.location.pathname) && (
            <SocailMediaLogin isFromSignUp />
          )}
      </div>
    </div>
  );

  const renderOtpFiled = () => (
    <OTPDialog
      open={openOtpDialog}
      // onClose={() => setOpenOtpDialog(false)}
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
      handleVerifyOtp={handleVerifyOtp}
      countdown={countdown}
      handleResendClick={handleResendClick}
      verifyOtp={verifyOtp}
    />
  );

  return (
    <div>
      <div className="mt-3">
        <form onSubmit={handleSubmit(onClickBtn)} className="container">
          {!openOtpDialog ? renderRegisterFields() : renderOtpFiled()}
        </form>
      </div>
      {renderFooterLine()}

      <ErrorSnackBar opensnackbar={opensnackbar} handleClose={handleClose} />
      <SuggestNameDialog
        isSuggestDialogOpen={isSuggestDialogOpen}
        setSuggestDialogVisible={setSuggestDialogVisible}
        email={watch('email')}
      />
    </div>
  );
}
Register.propTypes = {
  setShowNavBar: PropTypes.func,
  setHideRegisterDialog: PropTypes.func,
  showOTPDlgTitle: PropTypes.bool,
};
Register.defaultProps = {
  setShowNavBar: noop,
  setHideRegisterDialog: noop,
  showOTPDlgTitle: undefined,
};

export default Register;
